function firstDefined(...values) {
  return values.find(value => value !== undefined && value !== null);
}

function normalizeId(value) {
  if (value === undefined || value === null || value === '') return null;
  return value;
}

export function normalizeTaskPlace(raw = null) {
  if (!raw || typeof raw !== 'object') return null;

  return {
    ...raw,
    id: normalizeId(firstDefined(raw.id, raw.placeId, raw.place_id, raw.taskPlaceId, raw.task_place_id)),
    name: firstDefined(raw.name, raw.title, raw.placeName, raw.place_name, ''),
    ai_subtitle: firstDefined(raw.ai_subtitle, raw.aiSubtitle, raw.subtitle, null),
    background_image_url: firstDefined(raw.background_image_url, raw.backgroundImageUrl, null)
  };
}

export function normalizeTask(raw = null) {
  if (!raw || typeof raw !== 'object') return null;

  const place = normalizeTaskPlace(firstDefined(raw.place, raw.taskPlace, raw.location, null));
  const placeId = normalizeId(firstDefined(
    raw.place_id,
    raw.placeId,
    raw.taskPlaceId,
    raw.task_place_id,
    raw.locationId,
    place?.id
  ));

  return {
    ...raw,
    id: normalizeId(firstDefined(raw.id, raw.taskId, raw.task_id)),
    main_task: firstDefined(raw.main_task, raw.mainTask, raw.title, ''),
    place_id: placeId,
    place,
    meta: raw.meta && typeof raw.meta === 'object' ? raw.meta : {}
  };
}

export function normalizeTaskList(items = []) {
  if (!Array.isArray(items)) return [];

  const seen = new Set();
  return items
    .map(normalizeTask)
    .filter(Boolean)
    .filter(task => {
      const key = String(task.id || '');
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}
